<p-chart
  type="line"
  [data]="data"
  [options]="options"
  [style.background-color]="bgColor" />
